const Requests = {
  p01Mst001Structurematerial: 'master/parts/structurematerial',  // GETメソッド
  p01Mst101CostByHonbu: 'master/hanbai/costbyhonbu',  // GET,PUT,DELETE,CHECKメソッド
  p01Mst101CostByLine: 'master/hanbai/costbyline',  // GET,PUT,DELETE,CHECKメソッド
};

export default Requests;